import { AnnualReviewSupervisorAnswers } from '../types';
import { ANNUAL_REVIEW_RATINGS, CORE_VALUES_SUBITEMS } from './questionsCatalog';

export const computeSupervisorCompletedKeys = (
  answers: AnnualReviewSupervisorAnswers | null | undefined,
): Set<string> => {
  const done = new Set<string>();
  if (!answers) return done;
  const ratings = answers.ratings || {};
  ([1, 2, 3, 4] as const).forEach((section) => {
    const items = ANNUAL_REVIEW_RATINGS.filter((q) => q.section === section);
    const allRated = items.every((q) => typeof ratings[q.key] === 'number');
    const coreOk = section !== 4 || CORE_VALUES_SUBITEMS.every((s) => typeof ratings[s.key] === 'number');
    if (allRated && coreOk) {
      done.add(`section_${section}`);
    }
  });
  const dr = answers.directorReview || {};
  const strengths = (dr.topStrengths || []).filter((s) => s?.trim().length).length;
  const opps = (dr.opportunitiesForGrowth || []).filter((s) => s?.trim().length).length;
  if (strengths >= 1 && opps >= 1) done.add('director_review');
  return done;
};

export const computeSupervisorMissingForStep = (
  stepKey: string,
  answers: AnnualReviewSupervisorAnswers | null | undefined,
): string[] => {
  if (!answers) return [];
  const ratings = answers.ratings || {};
  if (stepKey.startsWith('section_')) {
    const section = Number(stepKey.split('_')[1]);
    const missing: string[] = [];
    ANNUAL_REVIEW_RATINGS.filter((q) => q.section === section).forEach((q) => {
      if (typeof ratings[q.key] !== 'number') missing.push(q.title);
    });
    if (section === 4) {
      CORE_VALUES_SUBITEMS.forEach((s) => {
        if (typeof ratings[s.key] !== 'number') missing.push(`Core Values: ${s.label.split(' – ')[0]}`);
      });
    }
    return missing;
  }
  if (stepKey === 'director_review') {
    const dr = answers.directorReview || {};
    const strengths = (dr.topStrengths || []).filter((s) => s?.trim().length).length;
    const opps = (dr.opportunitiesForGrowth || []).filter((s) => s?.trim().length).length;
    const missing: string[] = [];
    if (strengths < 1) missing.push('At least 1 Top Strength');
    if (opps < 1) missing.push('At least 1 Opportunity for Growth');
    return missing;
  }
  return [];
};
